import { backendApiClient } from './apiClient';
import { AxiosRequestConfig } from 'axios';

// Keep local — importing PAL_BASE_URL from @geneo2-web/shared-ui creates a circular
// dependency (shared-ui WebinarListSection → services-clients → webinarApi → shared-ui).
const PAL_BASE_URL =
  process.env.NX_PAL_API_IS_LOCAL === 'true' ? '' : '/pal';

const WEBINAR_SERVICE_BASE = `${
  PAL_BASE_URL || ''
}/public/webinar.service.v1.WebinarService`;

/** Mirrors webinar.service.v1.WebinarListRole */
export enum WebinarListRole {
  UNSPECIFIED = 0,
  TEACHER = 1,
  STUDENT = 2,
  ADMIN = 3,
}

/** Mirrors webinar.service.v1.WebinarListStatus */
export enum WebinarListStatus {
  UNSPECIFIED = 0,
  ONGOING = 1,
  ENDED = 2,
}

export interface WebinarSlotInput {
  date: string; // yyyy-MM-dd
  startTime: string; // HH:mm
  durationMinutes: number;
  timezone?: string;
}

export interface CreateWebinarRequest {
  schoolId: number;
  title: string;
  description?: string;
  hostName: string;
  hostZoomEmail: string;
  grade?: string;
  section?: string;
  teacherIds?: number[];
  studentIds?: number[];
  inviteEmails?: string[];
  recordingEnabled?: boolean;
  externalParticipantRegistration?: boolean;
  slots: WebinarSlotInput[];
  customJoinUrl?: string;
}

export interface WebinarSlotDto {
  id?: number;
  webinarId: number;
  schoolId: number;
  startTime?: string;
  endTime?: string;
  durationMinutes: number;
  timezone: string;
  zoomMeetingId?: string;
  zoomJoinUrl?: string;
  zoomStartUrl?: string;
  zoomPassword?: string;
  status: number;
  failureReason?: string;
}

export interface WebinarDto {
  id?: number;
  schoolId: number;
  title: string;
  description?: string;
  hostName: string;
  hostZoomEmail: string;
  grade?: string;
  section?: string;
  teacherIds?: number[];
  studentIds?: number[];
  inviteEmails?: string[];
  recordingEnabled: boolean;
  externalParticipantRegistration: boolean;
  status: number;
  slots?: WebinarSlotDto[];
  createdAt?: string;
}

export interface CreateWebinarResponse {
  webinar?: WebinarDto;
}

export interface WebinarListItem {
  slot?: WebinarSlotDto;
  webinar?: WebinarDto;
}

export interface GetWebinarListRequest {
  role: WebinarListRole;
  profileId: number;
  schoolId: number;
  status: WebinarListStatus;
  pagination?: { page: number; limit: number };
}

export interface GetWebinarListResponse {
  items: WebinarListItem[];
  totalCount: number;
  page: number;
  limit: number;
}

export async function createWebinarApi(
  body: CreateWebinarRequest,
  options: AxiosRequestConfig = {}
): Promise<CreateWebinarResponse> {
  return backendApiClient.post<CreateWebinarResponse>(
    `${WEBINAR_SERVICE_BASE}/CreateWebinar`,
    body,
    options
  );
}

export async function getWebinarListApi(
  body: GetWebinarListRequest,
  options: AxiosRequestConfig = {}
): Promise<GetWebinarListResponse> {
  return backendApiClient.post<GetWebinarListResponse>(
    `${WEBINAR_SERVICE_BASE}/GetWebinarList`,
    body,
    options
  );
}
